module.exports = __webpack_public_path__ + "static/media/trag-illustration.85d7dc89.png";